module.exports = __webpack_public_path__ + "images/f0aad4611fca0ba9a56e93f1910b557f8b60ff32503b45c27fbd6897f176aec6.svg";